import { TIPO_REFERENCIAS, TIPO_REFERENCIAS_LABORALES } from './TIPO_REFERENCIAS'
import municipio from '@src/store/modules/municipio'

export default class ReferenciaDto {
  nombre
  telefono
  tiempoConocerse
  comoConocerse
  fk_idCatTipoReferencia
  fk_idCatOcupacion
  fk_idPersonal
  fk_idDireccion
  ultimaActualizacion
  vigente
  direccion
  referenciasDetalleLabor

  constructor() {
    this.nombre = ''
    this.telefono = ''
    this.tiempoConocerse = 0
    this.comoConocerse = ''
    this.fk_idCatTipoReferencia = TIPO_REFERENCIAS.VECINAL
    this.fk_idCatOcupacion = null
    this.fk_idPersonal = null
    this.fk_idDireccion = null
    this.ultimaActualizacion = new Date()
    this.vigente = true

    this.direccion = {
      calle: '',
      colonia: '',
      cp: '',
      entrecalles: '',
      entrecalles2: '',
      exterior: '',
      fecharegistro: new Date(),
      fk_idmunicipio: null,
      interior: '',
      lat: null,
      lgt: null,
      localidad: '',
      referencias: '',
    }

    this.referenciasDetalleLabor = {
      cargo: '',
      corporacion: '',
      tiempoLaborado: 0,
    }
  }

  fromEntity(referenciaEntity) {
    if (referenciaEntity.id) {
      this.id = referenciaEntity.id
    }

    if (referenciaEntity.idDireccion) {
      this.fk_idDireccion = referenciaEntity.idDireccion
    }

    if (referenciaEntity.idReferenciasDetalleLabor) {
      this.fk_idReferenciasDetalleLabor = referenciaEntity.idReferenciasDetalleLabor
    }

    this.nombre = referenciaEntity.nombre
    this.telefono = referenciaEntity.telefono
    this.fk_idCatTipoReferencia = referenciaEntity.tipo

    if (TIPO_REFERENCIAS_LABORALES.includes(referenciaEntity.tipo)) {
      this.referenciasDetalleLabor.cargo = referenciaEntity.cargo
      this.referenciasDetalleLabor.corporacion = referenciaEntity.corporacion
      this.referenciasDetalleLabor.tiempoLaborado = referenciaEntity.tiempoLaborado
      this.direccion = null
    }

    if (referenciaEntity.tipo === TIPO_REFERENCIAS.PERSONAL) {
      this.tiempoConocerse = referenciaEntity.tiempoConocerse
      this.comoConocerse = referenciaEntity.comoConocio
      this.referenciasDetalleLabor = null
      this.direccion = null
    }

    if (referenciaEntity.tipo === TIPO_REFERENCIAS.VECINAL) {
      this.tiempoConocerse = referenciaEntity.tiempoConocerse
      this.referenciasDetalleLabor = null

      this.direccion.fk_idmunicipio = referenciaEntity.fk_idmunicipio
      this.direccion.colonia = referenciaEntity.colonia
      this.direccion.calle = referenciaEntity.calle
      this.direccion.exterior = referenciaEntity.exterior
      this.direccion.interior = referenciaEntity.interior
      this.direccion.entrecalles = referenciaEntity.entrecalles
      this.direccion.entrecalles2 = referenciaEntity.entrecalles2
      this.direccion.referencias = referenciaEntity.referencias
      this.direccion.cp = referenciaEntity.cp
      this.direccion.localidad = referenciaEntity.localidad
    }

    return this
  }
}
